import { render, staticRenderFns } from "./articleCategory.vue?vue&type=template&id=557130bf&scoped=true"
import script from "./articleCategory.vue?vue&type=script&lang=js"
export * from "./articleCategory.vue?vue&type=script&lang=js"
import style0 from "./articleCategory.vue?vue&type=style&index=0&id=557130bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557130bf",
  null
  
)

export default component.exports